var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#E04B4B"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_998_2505)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.047 9.57171C20.915 8.06854 23.085 8.06855 23.953 9.57171L34.6945 28.1733C35.5625 29.6765 34.4775 31.5554 32.7415 31.5554H11.2585C9.52249 31.5554 8.43749 29.6765 9.30549 28.1733L20.047 9.57171ZM23.1545 20.8859V16.4794H20.8925V20.8859C20.8925 21.3584 20.9211 21.8283 20.9783 22.2957C21.0355 22.7579 21.1109 23.2304 21.2045 23.7131H22.8425C22.9361 23.2304 23.0115 22.7579 23.0687 22.2957C23.1259 21.8283 23.1545 21.3584 23.1545 20.8859ZM20.7287 25.978C20.6611 26.1372 20.6273 26.3093 20.6273 26.4942C20.6273 26.6791 20.6611 26.8537 20.7287 27.018C20.8015 27.1772 20.8977 27.3159 21.0173 27.434C21.1421 27.5522 21.2877 27.6446 21.4541 27.7114C21.6205 27.7781 21.8025 27.8115 22.0001 27.8115C22.1925 27.8115 22.3719 27.7781 22.5383 27.7114C22.7047 27.6446 22.8503 27.5522 22.9751 27.434C23.0999 27.3159 23.1961 27.1772 23.2637 27.018C23.3365 26.8537 23.3729 26.6791 23.3729 26.4942C23.3729 26.3093 23.3365 26.1372 23.2637 25.978C23.1961 25.8188 23.0999 25.6802 22.9751 25.562C22.8503 25.4439 22.7047 25.3515 22.5383 25.2847C22.3719 25.2128 22.1925 25.1769 22.0001 25.1769C21.8025 25.1769 21.6205 25.2128 21.4541 25.2847C21.2877 25.3515 21.1421 25.4439 21.0173 25.562C20.8977 25.6802 20.8015 25.8188 20.7287 25.978Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_998_2505"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white",
    transform: "translate(9 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.01d27f52b73b93393815ca7a93cd82a1.svg";
export { ForwardRef as ReactComponent };